export const joinFilters = (filters: (string | undefined)[]): string => {
    return filters.filter(Boolean).join(' ').trim();
};
